module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/create-property-descriptor.js
// module id = 57
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35